import '../tabs.scss';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';
import Button from 'react-bootstrap/Button';

import LabTable from '../../../components/lab-table';
import SingleSelect from '../../../components/single-select';
import Well from '../../../components/well';
import { SORT_DIRECTIONS } from '../../../constants';

const { ASC, DESC } = SORT_DIRECTIONS;

class LabTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            orderBy: 'id',
            dir: ASC,
            where: {},
            loadingMore: false,
        };

        if (R.isEmpty(props.labReducer.productResults)) {
            props.fetchProducts();
        }

        if (R.isEmpty(props.labReducer.labResults)) {
            props.fetchLabItems(this.fetchParams());
        }

        this.changeOrderBy = R.bind(this.changeOrderBy, this);
        this.handleFilter = R.bind(this.handleFilter, this);
        this.handleLoadMore = R.bind(this.handleLoadMore, this);
    }

    componentDidMount() {
        // Reload the table if the user came from a lab page. Without this if the user hits the back button
        // on a lab page, the product filter will not populate correctly.
        if (!R.isEmpty(this.props.labReducer.currentLab)) {
            window.location.reload();
        }
    }

    //The sort/filter/product params of the current view. Paging (offset) is deliberately
    //not component state: replace fetches always restart at offset 0 (the action default)
    //and Load More derives the next offset from the store's pagination slice.
    fetchParams() {
        return R.pick(['orderBy', 'dir', 'where'], this.state);
    }

    changeOrderBy(orderBy) {
        if (!orderBy) {
            return;
        }

        const filter = {
            orderBy,
            dir: orderBy === this.state.orderBy && this.state.dir === ASC ? DESC : ASC,
        };

        this.setState(filter);
        //Preserve the active product filter and restart paging from the first page
        this.props.fetchLabItems(R.mergeRight(this.fetchParams(), R.mergeRight(filter, { offset: 0 })));
    }

    handleFilter({ target }) {
        const where = {
            where: {
                product_id: target.value,
            },
        };

        this.setState(where);
        //Restart paging from the first page for the newly filtered list
        this.props.fetchLabItems(R.mergeRight(this.fetchParams(), R.mergeRight(where, { offset: 0 })));
    }

    handleLoadMore() {
        const { pagination } = this.props.labReducer;

        this.setState(() => ({ loadingMore: true }));
        this.props
            .fetchLabItems(R.mergeRight(this.fetchParams(), { offset: pagination.offset + pagination.limit }))
            .finally(() => this.setState(() => ({ loadingMore: false })));
    }

    productOptions() {
        return R.map(
            (prod) => ({
                label: prod.name,
                value: prod.id,
            }),
            this.props.labReducer.productResults,
        );
    }

    render() {
        const { labResults, pagination = {} } = this.props.labReducer;

        return (
            <div className="lab-tab">
                <Well>
                    <SingleSelect
                        id="product_id"
                        label="Filter By Product"
                        selected={R.path(['where', 'product_id'], this.state)}
                        options={this.productOptions()}
                        onChange={this.handleFilter}
                    />
                    {this.props.appReducer.appAccess.write ? (
                        <Button variant="success" onClick={this.props.clearLabDetails}>
                            {' '}
                            Add Lab{' '}
                        </Button>
                    ) : null}
                </Well>
                <LabTable
                    appAccess={this.props.appReducer.appAccess}
                    labs={labResults}
                    changeOrderBy={this.changeOrderBy}
                    orderBy={this.state.orderBy}
                    dir={this.state.dir}
                />
                {R.isEmpty(labResults) ? null : (
                    <div className="lab-table-footer">
                        <span className="lab-count">{`Showing ${labResults.length} labs`}</span>
                        {pagination.hasMore ? (
                            <Button variant="secondary" onClick={this.handleLoadMore} disabled={this.state.loadingMore}>
                                {this.state.loadingMore ? 'Loading...' : 'Load More'}
                            </Button>
                        ) : null}
                    </div>
                )}
            </div>
        );
    }
}

LabTab.propTypes = {
    appReducer: PropTypes.object,
    labReducer: PropTypes.object,
    fetchLabItems: PropTypes.func,
    fetchProducts: PropTypes.func,
    clearLabDetails: PropTypes.func,
};

export default LabTab;
